import React from 'react';
import './Menus.scss';
import Lottie from 'lottie-react';
import { map } from 'lodash-es';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import loader from '../../assets/lotties/loader.json';
import { EditItem } from '../../modules/EditItem/EditItem';
import { DeleteItem } from '../../modules/DeleteItem/DeleteItem';
import { useDeleteMenuMutation, useGetMenusQuery, useInitMenuMutation } from '../../store/menu/menuApi';

export const Menus = (): JSX.Element => {
	const { data: menus, isLoading: isLoadingMenus } = useGetMenusQuery();
	const [deleteMenu] = useDeleteMenuMutation();
	const [initNewMenu] = useInitMenuMutation();

	const navigate = useNavigate();

	const addMenuHandler = async (): Promise<void> => {
		try {
			const data = await initNewMenu().unwrap();

			navigate(`/menu/${data.id}`);
			toast.success('תפריט חדש נוצר בהצלחה');
		} catch (error) {
			console.error('Error initializing new menu:', error);
			toast.error('שגיאה ביצירת תפריט חדש');
		}
	};

	const handleEditClick = (menuId: string): void => {
		navigate(`/menu/${menuId}`);
	};

	const handleDeleteClick = (menuId: string): void => {
		deleteMenu(menuId)
			.then(() => {
				toast.success('תפריט נמחק בהצלחה');
			})
			.catch((error) => {
				console.error('Error deleting menu:', error);
				toast.error('שגיאה במחיקת תפריט');
			});
	};

	return (
		<div className="menusContainer">
			{isLoadingMenus ? (
				<Lottie animationData={loader} loop style={{ width: '10rem' }} />
			) : (
				<>
					{map(menus, (menu) => (
						<div key={menu.id} className="menuItem">
							<span>שם התפריט: {menu.title}</span>
							<div className="menuActions">
								<EditItem onClick={(): void => handleEditClick(menu.id)} />
								<DeleteItem onClick={(): void => handleDeleteClick(menu.id)} />
							</div>
						</div>
					))}
					<div className="addMenu" onClick={addMenuHandler}>
						הוסף תפריט +
					</div>
				</>
			)}
		</div>
	);
};
